import { Component, OnInit, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DataTableFilterMessageService } from '../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { OrganizationsFilterStateService } from '../../services/organizations-filter-state.service';
import { OrganizationsMessageService } from '../../services/organizations-message.service';
import { BaseDataTableFilter } from '../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';

@Component({
  selector: 'app-organizations-filter-status',
  templateUrl: './organizations-filter-status.component.html',
  styleUrls: ['./organizations-filter-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    FormsModule
  ]
})
export class OrganizationsFilterStatusComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private filterStateService: OrganizationsFilterStateService,
    private filterMessageService: DataTableFilterMessageService,
    private organizationsMessageService: OrganizationsMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.filterStateService.status != 0) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onApplyClicked(): void {
    this.organizationsMessageService.applyFilter();

    const isActive = this.filterStateService.status != 0;

    let statusText;
    if (this.filterStateService.status == 1) {
      statusText = "Active";
    }
    if (this.filterStateService.status == 2) {
      statusText = "Inactive";
    }
    this.filterMessageService.setActive({ filterId: this.id, active: isActive, value: statusText });
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilter();
    this.organizationsMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): OrganizationsFilterStateService {
    return this.filterStateService;
  }

  openedChange(opened: boolean) {
    const clickoutEnabled = !opened;
    this.filterMessageService.setClickoutEnabled(clickoutEnabled);
  }

  private getFilterStatusText(): string {
    let statusText = '';
    if (this.filterStateService.status == 1) {
      statusText = "ACTIVE";
    }
    if (this.filterStateService.status == 2) {
      statusText = "INACTIVE";
    }

    return statusText;
  }
}